/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Applicable_Plans_HintInputs */

const en_admin_discounts_applicable_plans_hint = /** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the plans this discount applies to`)
};

const de_admin_discounts_applicable_plans_hint = /** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle die Tarife aus, für die dieser Rabatt gilt`)
};

const es_admin_discounts_applicable_plans_hint = /** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona los planes a los que se aplica este descuento`)
};

const fr_admin_discounts_applicable_plans_hint = /** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les forfaits auxquels cette réduction s'applique.`)
};

/** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */
const it_admin_discounts_applicable_plans_hint = en_admin_discounts_applicable_plans_hint;

/** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_applicable_plans_hint = en_admin_discounts_applicable_plans_hint;

/** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */
const pl_admin_discounts_applicable_plans_hint = en_admin_discounts_applicable_plans_hint;

/** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */
const hu_admin_discounts_applicable_plans_hint = en_admin_discounts_applicable_plans_hint;

/** @type {(inputs: Admin_Discounts_Applicable_Plans_HintInputs) => LocalizedString} */
const ro_admin_discounts_applicable_plans_hint = en_admin_discounts_applicable_plans_hint;

/**
* | output |
* | --- |
* | "Select the plans this discount applies to" |
*
* @param {Admin_Discounts_Applicable_Plans_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_applicable_plans_hint = /** @type {((inputs?: Admin_Discounts_Applicable_Plans_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Applicable_Plans_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "de") return de_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "es") return es_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "it") return it_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_applicable_plans_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_applicable_plans_hint(inputs)
	return ro_admin_discounts_applicable_plans_hint(inputs)
});
export { admin_discounts_applicable_plans_hint as "admin.discounts.applicable_plans_hint" }